import { useQuery } from 'hooks/useCustomQuery';
import { getNumber } from '@/API/Numbers/getNumber';

const useGetNumberById = (
    numberId,
    setEditNumberData,
    setPreviousEditNumberData,
) => {
    return useQuery({
        queryKey: ['number', numberId],
        queryFn: async () => {
            try {
                const data = await getNumber(numberId).then((res) => {
                    setEditNumberData(res);
                    setPreviousEditNumberData(res);
                    return res;
                });
                return data;
            } catch (error) {
                console.error('Error fetching number:', error);
                throw error;
            }
        },
        refetchOnWindowFocus: false,
        enabled: !!numberId,
        staleTime: 0,
    });
};

export default useGetNumberById;
